import React, { useState, useEffect } from 'react';
import { css } from '@emotion/css';
import { color_colors_decline, color_shades_darkest, color_variants_decline_light_1, color_colors_gold, color_variants_gold_light } from '../../constants/colors';
import styled from '@emotion/styled';

const alertIcon = require('../../content/images/alert-circle.svg');
const checkIcon = require('../../content/images/check-circle.svg');
const warningIcon = require('../../content/images/alert-triangle-yellow.svg');

interface PageErrorProps {
    errors?: string[]
    onClear?: () => void,
    className?: string,
    type?: 'error' | 'success' | 'warning'
}

const PageError: React.FC<PageErrorProps> = ({ errors = [], onClear, className, type = 'error' }) => {
    const [displayErrors, setDisplayErrors] = useState<string[]>(errors);

    useEffect(() => {
        setDisplayErrors(errors);
    }, [errors]);

    const handleClick = () => {
        setDisplayErrors([]);
        if (onClear) {
            onClear();
        }
    };

    if (!displayErrors || displayErrors.length === 0) {
        return null;
    }

    const isSuccess = type === 'success';
    const isWarning = type === 'warning';

    const containerClass = isSuccess ? successContainerStyle : isWarning ? warningContainerStyle : containerStyle;
    const icon = isSuccess ? checkIcon : isWarning ? warningIcon : alertIcon;

    return (
        <div onClick={handleClick}>
            <div className={`${containerClass} ${className?.length ? className : ""}`}>
                <AlertIconStyle src={icon} />
                <div>
                    {displayErrors.map((e, i) => <p className={isSuccess ? "success-text" : isWarning ? "warning-text" : "error-text"} key={i}>{e?.toString() ?? ''}</p>)}
                </div>
            </div>
        </div>
    );
};
const containerStyle = css`
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 32;
    width: 360px;
    background: ${color_variants_decline_light_1};
    border: 1px solid ${color_colors_decline};
    padding: 16px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    cursor: pointer;
    z-index: 999;
    .error-text {
        color: ${color_shades_darkest};
        font-family: Muli;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
    } 
`

const successContainerStyle = css`
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    bottom: 32;
    width: 360px;
    background: #d4edda;
    border: 1px solid #28a745;
    padding: 16px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    cursor: pointer;
    z-index: 999;
    .success-text {
        color: #155724;
        font-family: Muli;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
    } 
`

const warningContainerStyle = css`
    display: flex;
    align-items: center;
    position: fixed;
    right: 0;
    bottom: 32px;
    width: 360px;
    background: ${color_variants_gold_light};
    border: 1px solid ${color_colors_gold};
    padding: 16px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    cursor: pointer;
    z-index: 999;
    .warning-text {
        color: ${color_shades_darkest};
        font-family: Muli;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
    }
`

const AlertIconStyle = styled.img`
    height: 24px;
    width: 24px;
    margin-right: 8px;
`;

export default PageError;